import styled from "styled-components";

import { SPACING } from "../../../../utils/constants";

export const CurrentRateBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.md}px;
  padding: ${SPACING.md}px;
  border-radius: 12px;
  background: var(--color-tab-background);
`;

export const CurrentRateLabel = styled.span`
  font-size: var(--text-xs);
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-text-secondary);
`;

export const CurrentRateValue = styled.span`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-xl);
  font-weight: 700;
  color: var(--color-text-default);
`;
